import * as Sentry from '@sentry/browser';

export const captureErrorInSentry = (error: unknown, extras = {}) => {
  Sentry.withScope((scope) => {
    scope.setExtras(extras);
    Sentry.captureException(error);
  });
};

export const captureMessageInSentry = (message: string, extras = {}) => {
  Sentry.withScope((scope) => {
    scope.setExtras(extras);
    Sentry.captureMessage(message);
  });
};
